import React from 'react'

import Horizontal from '../layouts/Horizontal.jsx'
import Card from '../components/Card.jsx'
import LoadingState from '../components/LoadingState.jsx'

import { getIncomeDistribution } from '_services/insights-v2.js'
import useRequest from '../hooks/useRequest.js'

import BarStackedCartesianHOC from '../charts/BarStackedCartesianHOC.jsx'
import { formatIncomeBy, INCOMES_MAP } from '../../charts/helpers/formatters.js'

const COLORS = ['#228352']

const IncomeDistribution = (props) => {
  const {
    audience: { _id: audienceId },
  } = props
  const { title, description, section_1 } = props.data

  const { data, loading } = useRequest(getIncomeDistribution, { audienceId, timeRange: null }, true)

  const formatted = formatIncomeBy(data, INCOMES_MAP, false)

  return (
    <Horizontal
      title={title}
      description={description}
      page={props.index + 1}
      content={() => (
        <Card title={section_1.title} description={section_1.subtitle} showBorder={false}>
          <Choose>
            <When condition={loading}>
              <LoadingState />
            </When>
            <Otherwise>
              <BarStackedCartesianHOC
                data={formatted}
                colors={COLORS}
                mode="single"
                labels={{ y: 'Users %', x: 'Income' }}
              />
            </Otherwise>
          </Choose>
        </Card>
      )}
    />
  )
}

export default IncomeDistribution
